import { parseBonusSheetJsonData } from "./bonusSheetParser";

/** Keys commonly stored on bonus sheet JSON for the person receiving the bonus. */
const DIRECT_BONUS_RECIPIENT_KEYS = [
  "bonusRecipientName",
  "bonusRecipientEmail",
  "applicantName",
  "applicantEmail",
  "managerName",
  "managerEmail",
] as const;

const NESTED_RECIPIENT_KEY = /(bonusRecipient|applicant|manager)(Name|Email)$/i;

function collectNestedRecipientStrings(obj: unknown, parts: string[], depth: number): void {
  if (depth <= 0 || obj === null || typeof obj !== "object") return;
  for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
    if (typeof v === "string" && v.trim() && NESTED_RECIPIENT_KEY.test(k)) {
      parts.push(v);
    } else if (typeof v === "object" && v !== null) {
      collectNestedRecipientStrings(v, parts, depth - 1);
    }
  }
}

/**
 * Lowercase blob for client-side search: employee (DB recipient) plus name/email fields from bonus sheet JSON.
 */
export function getBonusRecipientSearchBlob(app: {
  employeeName?: string;
  bonusRecipientEmail?: string | null;
  bonusRecipientEmployeeName?: string | null;
  bonusSheet?: string;
}): string {
  const parts: string[] = [];
  if (app.employeeName) parts.push(String(app.employeeName));
  if (app.bonusRecipientEmail) parts.push(String(app.bonusRecipientEmail));
  if (app.bonusRecipientEmployeeName) parts.push(String(app.bonusRecipientEmployeeName));
  if (!app.bonusSheet) return parts.join(" ").toLowerCase();
  const json = parseBonusSheetJsonData(app.bonusSheet) as Record<string, unknown>;
  for (const key of DIRECT_BONUS_RECIPIENT_KEYS) {
    const v = json[key];
    if (typeof v === "string" && v.trim()) parts.push(v);
  }
  collectNestedRecipientStrings(json, parts, 6);
  return parts.join(" ").toLowerCase();
}
